import getFrontConfig from '../../common/getFrontConfig';

const { productCustomizableTagCode } = getFrontConfig();

export const customizableProductMixin = {
  computed: {
    /**
     * Is a Customizable Product
     * @returns {boolean} True if customizable
     */
    isCustomizable() {
      const customTag = this.product?.bylCustomTag;
      return customTag && customTag.code === productCustomizableTagCode;
    },
  },
};

export default {
  props: {
    product: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
  },
  ...customizableProductMixin,
};
